(function() {
    'use strict';

    angular
        .module('app.service')
        .factory('enumService', enumService);

    function enumService() {
        var service = {
            sso: {},
            redirectType: {},
            target: {},
            sendTarget: {},
            siteCode: {},
            courseType: {}
        };

        service.sso = {
            success: '100',
            notExist: '201',
            disable: '202',
            isLock: '203',
            lockUnReslove: '204',
            dwpError: '205',//2023-07-10 Johnson 資安2023
            tokenNotExist: '206',
            notHaveEmail: '210',
            notHavePhone: '211',
            notFindAccount: '212',
            emailAlreadyRegister: '219',
            dwpMustBigThan: '220',//2023-07-10 Johnson 資安2023
            dwpNotSameAccount: '221',//2023-07-10 Johnson 資安2023
            dwpJustEnAndNumber: '222',//2023-07-10 Johnson 資安2023
            dwpNeedContainEnAndNumber: '223',//2023-07-10 Johnson 資安2023
            dwpNotContainueThree: '224',//2023-07-10 Johnson 資安2023
            dwpNotContainueThreeOrderAndDesc: '225',//2023-07-10 Johnson 資安2023
            dwpNotSameRecent: '226',//2023-07-10 Johnson 資安2023
            accountIsNotActive: '227',
            verifyCodeNotExist: '228',
            verifyCodeExpired: '229',
            dwpModifyWeek: '230',//2023-07-10 Johnson 資安2023
            dwpErrorIsLock: '231',//2023-07-10 Johnson 資安2023
            mustModifydwP: '232',//2023-07-10 Johnson 資安2023
            verifyCodeNotPass: '234',
            illegalRegister: '235',
            newdwPNotSameOlddwP: '236',
            userAlreadyValidate: '237',
            waitForLock: '238',
            error: '300',
            verifyCodeInValid: '500',
            isTaiEmail: '301',
            reCaptchaFail:'999'
        };

        service.redirectType = {
            direct: 0,
            open: 1
        };

        service.target = {
            open: 1,
            wrap: 2,
            direct: 3
        };

        service.sendTarget = {
            email: 1,
            sms: 2
        };

        service.siteCode = {
            hrInside: 1,
            hrOutside: 2,
            hrAdmin: 3,
            tsunOut: 4,
            tsunInside: 5
        };

        service.courseType = {
            webCourse: 1,
            classCourse: 2,
            externalCourse: 3,
            webTest: 4,
            classTest: 5,
            questList: 6,
            courage: 7
        };

        return service;
    }
})();
